import { shuffle } from './main';
/* Copyright 2013-2016 Christopher Cady */
export default function Bingo(worksheet) {
	this.worksheet = worksheet;
	this.terms = localStorage.getItem("terms").split("\n");
	this.definitions = localStorage.getItem("definitions").split("\n");
	this.size = parseInt(localStorage.getItem("bingoSize"));
	switch (this.size) {
		case 3:
			this.cards = 48;
			break;
		case 5:
			this.cards = 48;
			break;
		default:
			this.cards = 48;
	}
	this.termArrays = [];
	this.free = localStorage.getItem("bingoFree");
	for (var i = 0; i < this.cards; i++) {
		shuffle(this.terms);
		this.termArrays[i] = [];
		for (var j = 0; j < this.terms.length; j++) {
			this.termArrays[i].push(this.terms[j]);
		}
		switch (this.free) {
			case "center":
				if (this.size == 3)
					this.termArrays[i].splice(4, 0, "free");
				else if (this.size == 5)
					this.termArrays[i].splice(12, 0, "free");
				break;
			case "random":
				this.termArrays[i].splice(Math.floor(Math.random() * this.size * this.size), 0, "free");
				break;
			default:
		}
	}
	this.createCard = function (terms, wrapper) {
		var card = document.createElement("table");
		card.className = 'bingoCard';
		for (var i = 0; i < this.size; i++) {
			var tr = document.createElement('tr');
			card.appendChild(tr);
			for (var j = 0; j < this.size; j++) {
				var td = document.createElement("td");
				td.className = 'cell';
				if (terms[this.size * j + i]) {
					td.innerHTML = terms[this.size * j + i];
					if (terms[this.size * j + i] == "free")
						td.className = "cell free";
				}
				tr.appendChild(td);
				renderMathInElement(td);
			}
		}
		wrapper.appendChild(card);
	};
	let cardWrapper = document.createElement('div');
	cardWrapper.className = 'bingoCardWrapper';
	for (var i = 0; i < this.cards; i++) {

		this.createCard(this.termArrays[i], cardWrapper);

	}
	this.worksheet.appendChild(cardWrapper);
}